import React, { Component } from "react";
import store from "../../store";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";

import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Navbar from "../Navbar/Navbar";
import GridCars from "../GridCars/GridCars";
import Footer from "../Footer/Footer";
import VideoPlayer from "../VideoPlayer/VideoPlayer";
import SimpleModal from "../Modal/Modal";

import { createMuiTheme } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import Grid from "@material-ui/core/Grid";
import { isMobile } from "react-device-detect";

const queryString = require("query-string");

const ColorButton = withStyles(theme => ({
  root: {
    fontFamily: "Arial",
    fontWeight: "bold",
    borderColor: green[500],
    backgroundColor: green[500],
    color: theme.palette.getContrastText(green[50]),
    color: green[50],
    borderRadius: 20,
    "&:hover": {
      backgroundColor: green[100],
      color: theme.palette.getContrastText(green[500]),
      color: green[700]
    }
  }
}))(Button);

const imgStyle = {
  width: "50%",
  height: "50%",
  display: "block",
  marginLeft: "auto",
  marginRight: "auto"
};

class MainMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: true,
      values: { redirect: false }
    };
  }
  componentDidMount() {
    console.log(this.props.location.search);
    this.setState({ values: queryString.parse(this.props.location.search) });
  }

  useStyles = () =>
    makeStyles(theme => ({
      button: {
        margin: theme.spacing(1),
        primary: green
      },
      input: {
        display: "none"
      }
    }));

  startHandler = () => {};

  leaderboardHandler = () => {};

  modalHandler = () => {
    this.setState({ modalOpen: !this.state.modalOpen });
  };

  playVideoHander = () => {
    if (!this.state.modalOpen && !this.state.values.redirect) {
      this.setState({ modalOpen: true });
    }
  };

  onCloseVideoPlayer = () => {
    this.setState({ modalOpen: false });
  };

  render() {
    const classes = this.useStyles();

    return (
      <Grid container xs={12}>
        <Grid item xs={12}>
          <Navbar onClick={this.playVideoHander} />
          <GridCars />
          {isMobile ? null : <Footer />}
        </Grid>
        <SimpleModal
          open={this.state.modalOpen && !this.state.values.redirect}
          onClose={this.onCloseVideoPlayer}
        >
          <VideoPlayer />
        </SimpleModal>
      </Grid>
    );
  }
}

export default MainMenu;
